var _style, _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderThick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgThick",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "25 25 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.thickPath{fill:url(#thickGradient);}\r\n\t")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "thickGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 27.3424,
    y1: 38.5,
    x2: 72.6576,
    y2: 38.5,
    gradientTransform: "matrix(1 0 0 1 0 -744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thickPath",
    d: "M69,50L69,50c-1.8,0-3.3-1.3-3.6-3.1c-1.4-7.2-7.7-12.6-15.3-12.6s-13.9,5.4-15.3,12.6C34.3,48.7,32.8,50,31,50 h0c-2.3,0-4.1-2.1-3.6-4.3C29.4,35,38.8,27,50,27s20.6,8,22.6,18.7C73,47.9,71.3,50,69,50z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    accumulate: "none",
    additive: "replace",
    attributeName: "transform",
    attributeType: "XML",
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    from: "0 50 50",
    repeatCount: "indefinite",
    restart: "always",
    to: "360 50 50",
    type: "rotate"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderThick);
export default __webpack_public_path__ + "static/media/loader-thick.67f64713.svg";
export { ForwardRef as ReactComponent };